import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  useToast,
  Tooltip,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import {
  DeleteIcon,
  ViewIcon,
  AddIcon,
  NotAllowedIcon,
} from '@chakra-ui/icons';
import moment from 'moment';
import AddModal from './addModal';
import EditModal from './editModal';
import PopDelete from './deletePopover';
import Card from 'components/card/Card';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';

import StoresApi from '../../../../../api/stores';
import PageError from 'components/nopermission/PageError';
export default function Branches(props) {
  // console.log(companyId);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [name, setName] = useState();
  const [displayOrder, setDisplayOrder] = useState();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [buy, setBuy] = useState();
  const [sell, setSell] = useState();
  const [exchange, setExchange] = useState();
  const { getPermissionsForModule } = usePermissions();
  const [storePermissions, setStorePermissions] = useState(null);

  // const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchStoreListError, setFetchStoreListError] = useState(false);
  const companyId = IdFromUrl(window.location.href);
  // console.log('Company ID = ', companyId);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  const FetchStoreList = async () => {
    try {
      setLoading(true);
      let response = await StoresApi.List({
        companyId,
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchStoreListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
        // console.log(list);
      } else {
        setFetchStoreListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchStoreListError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    const storePermissions = getPermissionsForModule([Modules.Store]);
    setStorePermissions(storePermissions);
  }, [searchTerm, currentPage]);

  useEffect(() => {
    if (storePermissions?.read) {
      FetchStoreList();
    }
  }, [storePermissions]);

  console.log('Store permissions', storePermissions);
  if (!storePermissions?.read) {
    return <NoPermissionsMessage module={Modules.Store} />;
  }

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  let totalPages = Math.ceil(listTotal / itemsPerPage);
  const pageItems = [];
  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(
      <Button
        key={i}
        size='sm'
        variant='ghost'
        colorScheme={i === currentPage ? 'blue' : undefined}
        onClick={() => onPageChange(i)}>
        {i}
      </Button>
    );
  }
  const handleSearch = async (search) => {
    setSearchTerm(search);
    setCurrentPage(1); // Reset currentPage to 1 on each search
  };

  const handleDelete = async (e) => {
    try {
      const id = [e.target.value];
      const response = await StoresApi.Delete({ id });
      if (response.data.statusCode === 1) {
        toast({
          title: 'Successfully Deleted',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      } else if (response.data.statusCode !== 1) {
        let error = response.data.error.errorMessage;
        toast({
          title: error,
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
      FetchStoreList();
    } catch (err) {
      console.log(err);
    }
  };
  const handleUpdate = async (onClose, id) => {
    try {
      let request = {
        id: id,
        name: name,
        display_order: Number(displayOrder),
      };
      const response = await StoresApi.Update({
        id,
        sell,
        buy,
        exchange,
      });
      if (response.data.status_code == 200) {
        toast({
          title: response?.data?.message || 'Successfully Updated',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        FetchStoreList();
      } else if (response.data.status_code != 200) {
        toast({
          title: response?.data?.message,
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  if (!storePermissions?.read) {
    return <NoPermissionsMessage module={Modules.SavingPlanStore} />;
  }

  if (!storePermissions?.read) {
    return <NoPermissionsMessage module={Modules.SavingPlanStore} />;
  }

  return fetchStoreListError ? (
    <PageError />
  ) : (
    <Flex direction='column'>
      <Flex
        px='25px'
        justify='space-between'
        mb='20px'
        align='center'>
        <Text
          pr='20px'
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          Existing Branches
        </Text>
        <Flex gap={4}>
          <Chakralink>
            <Link
              to={{
                pathname: `/admin/addnewstore/${companyId}`,
              }}>
              <Tooltip
                label={
                  !storePermissions.create
                    ? 'You do not have permission to add'
                    : undefined
                }
                placement='top'
                shouldWrapChildren>
                <Button
                  variant='lightBrand'
                  fontSize='sm'
                  fontWeight='500'
                  borderRadius='10px'
                  boxShadow='lg'
                  disabled={!storePermissions.create || !storePermissions.read}>
                  <AddIcon />
                </Button>
              </Tooltip>
            </Link>
          </Chakralink>
        </Flex>
      </Flex>

      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Sr.no
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Name
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  City
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  State
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Operation Location
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  E-mail
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {(currentPage - 1) * 10 + (index + 1)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.city}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.state}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.operation_location}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {/* {moment(obj.start).format('DD MMM YY, HH:mm')} */}
                        {obj.email}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={
                          obj.status === 'ACTIVE' ? 'green' : { textColor }
                        }
                        fontSize='sm'
                        fontWeight='700'>
                        {/* {moment(obj.start).format('DD MMM YY, HH:mm')} */}
                        {obj.status}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex justify='space-around'>
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/store/${obj.id}`,
                          }}>
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
